import { DEFAULT_FIELD_EXCEPTIONS } from '../constants';
import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

/**
 * Returns the entry for the given contentType and entryId.
 */
const _findOne = async function _findOne<T>(
    contentType: ContentTypeProps,
    entryId: string,
    fieldExceptions = DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview = false,
    lang: LocaleProps,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        return (await stackClient.stack
            .ContentType(contentType)
            .Entry(entryId)
            .language(lang)
            .except(fieldExceptions)
            .toJSON()
            .fetch()) as T;
    } catch (err) {
        throw new Error(`An error occurred in _findOne: ${err}`);
    }
};

const cached_findOne = unstable_cache(_findOne, ['search_findOne'], {
    revalidate: 1800,
});

export const findOne = async function findOne<T>(
    contentType: ContentTypeProps,
    entryId: string,
    fieldExceptions = DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview = false,
    lang: LocaleProps,
): Promise<T> {
    const fn = typeof window === 'undefined' ? cached_findOne : _findOne;

    return fn(contentType, entryId, fieldExceptions, enableLivePreview, lang);
};
